import { render, staticRenderFns } from "./BCOptionalFeaturesBattery.vue?vue&type=template&id=6d5922a6"
import script from "./BCOptionalFeaturesBattery.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesBattery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports